import React, { useEffect, useState } from "react";
import { Checkbox } from "@mui/material";
import { ChannelContainer, Container, Divider, Title, InputContainer } from "./styles";
import ChannelCard from "../../components/ChannelCard";
import { useUser } from "../../contexts/UserContext";
import Translator from "../../components/i18nComponents/Translator";
import { useTranslation } from "react-i18next";

export default function Channel() {
  const { listGroups, handleGetGroups } = useUser();
  const { t } = useTranslation();
  const [enableAdvance, setEnable] = useState(false);

  useEffect(() => {
    handleGetGroups();
  }, []);

  return (
    <Container>
      <Title><Translator path="paginas.configureChannels.Title" /></Title>
      <Divider />

      {/* Contêiner flexível para alinhar Checkbox e texto */}
      <InputContainer style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Checkbox
          checked={enableAdvance}
          name="enableAdvance"
          id="idEn"
          onChange={() => setEnable(!enableAdvance)}
        />
        <div>{t("componentes.ChannelCardComponente.advanceBox")}</div>
      </InputContainer>

      <ChannelContainer>
        {listGroups.map((channel, index) => (
          <ChannelCard
            channel={channel}
            key={index} // Considere usar channel.id se disponível
            enableAdvance={enableAdvance}
          />
        ))}
      </ChannelContainer>
    </Container>
  );
}